import { render, staticRenderFns } from "./FlashSaleList.vue?vue&type=template&id=634405e6&scoped=true&"
import script from "./FlashSaleList.vue?vue&type=script&lang=js&"
export * from "./FlashSaleList.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleList.vue?vue&type=style&index=0&id=634405e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634405e6",
  null
  
)

export default component.exports